var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 110,
    viewBox: "0 0 366 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352 109.1H14C6.6 109.1 0.5 103 0.5 95.6V14.5C0.5 7.1 6.6 1 14 1H352C359.4 1 365.5 7.1 365.5 14.5V95.6C365.5 103 359.4 109.1 352 109.1Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352 3.09991C358.3 3.09991 363.4 8.19991 363.4 14.4999V95.5999C363.4 101.9 358.3 107 352 107H14C7.7 107 2.60001 101.9 2.60001 95.5999V14.4999C2.60001 8.19991 7.7 3.09991 14 3.09991H352ZM352 0.899902H14C6.6 0.899902 0.5 6.9999 0.5 14.3999V95.4999C0.5 102.9 6.6 109 14 109H352C359.4 109 365.5 102.9 365.5 95.4999V14.3999C365.5 6.9999 359.4 0.899902 352 0.899902Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 28.6001C128.7 30.9001 128 32.7001 126.7 34.0001C125.2 35.6001 123.2 36.4001 120.7 36.4001C118.4 36.4001 116.4 35.6001 114.7 34.0001C113.1 32.4001 112.2 30.4001 112.2 28.0001C112.2 25.6001 113 23.6001 114.7 22.0001C116.3 20.4001 118.3 19.6001 120.7 19.6001C121.9 19.6001 123 19.8001 124 20.3001C125.1 20.8001 125.9 21.4001 126.5 22.1001L125.1 23.5001C124 22.2001 122.5 21.6001 120.7 21.6001C119 21.6001 117.5 22.2001 116.3 23.4001C115.1 24.6001 114.4 26.2001 114.4 28.1001C114.4 30.0001 115 31.6001 116.3 32.8001C117.5 34.0001 119 34.6001 120.7 34.6001C122.5 34.6001 124 34.0001 125.2 32.8001C126 32.0001 126.4 30.9001 126.6 29.5001H120.7V27.6001H128.6C128.7 27.8001 128.7 28.2001 128.7 28.6001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 28.5998C128.6 30.7998 127.9 32.5998 126.6 33.8998C125.1 35.4998 123.1 36.2998 120.7 36.2998C118.4 36.2998 116.4 35.4998 114.8 33.8998C113.2 32.2998 112.4 30.2998 112.4 27.8998C112.4 25.4998 113.2 23.4998 114.8 21.8998C116.4 20.2998 118.4 19.4998 120.7 19.4998C121.8 19.4998 122.9 19.6998 124 20.1998C125 20.5998 125.9 21.1998 126.5 21.9998L126.6 21.8998L126.5 21.7998L125.1 23.1998L125.2 23.2998L125.3 23.1998C124.2 21.8998 122.7 21.1998 120.8 21.1998C119.1 21.1998 117.6 21.7998 116.3 22.9998C115 24.1998 114.4 25.7998 114.4 27.7998C114.4 29.6998 115 31.2998 116.3 32.5998C117.6 33.7998 119.1 34.3998 120.8 34.3998C122.6 34.3998 124.2 33.7998 125.4 32.5998C126.2 31.7998 126.7 30.6998 126.8 29.2998V29.1998H120.9V27.4998H128.7V27.3998H128.6C128.6 27.7998 128.6 28.1998 128.7 28.5998H128.8C128.8 28.1998 128.8 27.7998 128.7 27.3998V27.2998H120.7V29.3998H126.7V29.2998H126.6C126.5 30.6998 126 31.7998 125.3 32.4998C124.1 33.6998 122.6 34.2998 120.8 34.2998C119.1 34.2998 117.7 33.6998 116.4 32.4998C115.2 31.2998 114.6 29.7998 114.6 27.8998C114.6 25.9998 115.2 24.4998 116.4 23.2998C117.6 22.0998 119.1 21.4998 120.8 21.4998C122.7 21.4998 124.1 22.0998 125.2 23.3998L125.3 23.4998L126.9 21.8998L126.8 21.7998C126.2 20.9998 125.3 20.3998 124.2 19.9998C123.1 19.4998 122 19.2998 120.8 19.2998C118.4 19.2998 116.4 20.0998 114.8 21.7998C113.1 23.3998 112.3 25.4998 112.3 27.8998C112.3 30.2998 113.1 32.3998 114.8 33.9998C116.5 35.5998 118.5 36.4998 120.8 36.4998C123.3 36.4998 125.3 35.6998 126.8 34.0998C128.2 32.6998 128.8 30.8998 128.7 28.5998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 21.7999H133.8V26.9999H140.4V28.8999H133.8V34.0999H141.2V36.0999H131.7V19.8999H141.2V21.7999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 21.7998V21.6998H133.7V27.0998H140.3V28.7998H133.7V34.1998H141.1V35.9998H131.8V19.9998H141.1V21.7998H141.2V21.6998V21.7998H141.3V19.7998H131.6V36.1998H141.3V33.9998H133.9V28.9998H140.5V26.8998H133.9V21.8998H141.3V21.7998H141.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150 36.0999H147.9V21.7999H143.3V19.8999H154.5V21.7999H150V36.0999Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150 36.0998V35.9998H148V21.6998H143.4V19.9998H154.4V21.6998H149.9V36.0998H150V35.9998V36.0998H150.1V21.8998H154.6V19.7998H143.2V21.8998H147.8V36.1998H150.1V36.0998H150Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7 19.8999H162.6V36.0999H164.7V19.8999Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.6 36.0998H162.7V19.9998H164.5V35.9998H162.6V36.0998H162.7H162.6V36.1998H164.7V19.7998H162.5V36.1998H162.6V36.0998Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.9 36.0999H171.8V21.7999H167.3V19.8999H178.4V21.7999H173.9V36.0999Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.9 36.0998V35.9998H171.9V21.6998H167.4V19.9998H178.3V21.6998H173.8V36.0998H173.9V35.9998V36.0998H174V21.8998H178.5V19.7998H167.2V21.8998H171.7V36.1998H174V36.0998H173.9Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 34C197.9 35.6 195.9 36.5 193.6 36.5C191.2 36.5 189.2 35.7 187.7 34C186.1 32.4 185.3 30.4 185.3 28C185.3 25.6 186.1 23.6 187.7 22C189.3 20.4 191.3 19.5 193.6 19.5C196 19.5 197.9 20.3 199.5 22C201.1 23.6 201.9 25.6 201.9 28C201.9 30.3 201.1 32.3 199.5 34ZM189.2 32.6C190.4 33.8 191.9 34.4 193.6 34.4C195.3 34.4 196.8 33.8 198 32.6C199.2 31.4 199.8 29.8 199.8 27.9C199.8 26 199.2 24.5 198 23.2C196.8 22 195.3 21.4 193.6 21.4C191.9 21.4 190.4 22 189.2 23.2C188 24.4 187.4 26 187.4 27.9C187.4 29.8 188 31.4 189.2 32.6Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.5 33.9999C197.9 35.5999 195.9 36.3999 193.6 36.3999C191.3 36.3999 189.3 35.5999 187.7 33.9999C186.1 32.3999 185.3 30.3999 185.3 28.0999C185.3 25.7999 186.1 23.7999 187.7 22.1999C189.3 20.5999 191.2 19.7999 193.6 19.7999C195.9 19.7999 197.9 20.5999 199.5 22.1999C201.1 23.7999 201.9 25.7999 201.9 28.0999C201.8 30.2999 201 32.2999 199.5 33.9999C201.2 32.3999 202 30.3999 202 27.9999C202 25.5999 201.2 23.5999 199.6 21.8999C198 20.1999 196 19.3999 193.6 19.3999C191.2 19.3999 189.2 20.1999 187.6 21.8999C186 23.5999 185.2 25.5999 185.2 27.9999C185.2 30.3999 186 32.3999 187.6 34.0999C189.2 35.7999 191.2 36.5999 193.6 36.5999C196 36.4999 198 35.6999 199.5 33.9999ZM189.2 32.5999C190.3 33.8999 191.8 34.4999 193.6 34.4999C195.4 34.4999 196.9 33.8999 198.1 32.5999C199.3 31.3999 199.9 29.7999 199.9 27.8999C199.9 25.9999 199.3 24.3999 198.1 23.1999C196.9 21.9999 195.4 21.2999 193.6 21.2999C191.8 21.2999 190.3 21.8999 189.1 23.1999C187.9 24.3999 187.3 25.9999 187.3 27.8999C187.3 29.8999 187.9 31.4999 189.2 32.5999C188.1 31.2999 187.5 29.7999 187.5 27.8999C187.5 25.9999 188.1 24.4999 189.3 23.2999C190.5 22.0999 191.9 21.4999 193.6 21.4999C195.3 21.4999 196.8 22.0999 197.9 23.2999C199.1 24.4999 199.7 25.9999 199.7 27.8999C199.7 29.7999 199.1 31.2999 197.9 32.4999C196.7 33.6999 195.3 34.2999 193.6 34.2999C191.9 34.2999 190.4 33.6999 189.2 32.5999Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 36.0999V19.8999H207.4L215.3 32.4999V29.2999V19.8999H217.3V36.0999H215.2L206.9 22.7999H206.8L206.9 25.9999V36.0999H204.8Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.8 36.0998H204.9V19.9998H207.3L215.2 32.5998H215.3H215.4V29.2998V19.9998H217.2V35.9998H215.2L207 22.6998H206.8H206.7L206.8 25.9998V35.9998H204.8V36.0998H204.9H204.8V36.1998H207V25.9998L206.9 22.7998H206.8V22.8998H206.9L215.1 36.1998H217.4V19.7998H215.2V29.2998V32.4998H215.3V32.3998L207.4 19.7998H204.7V36.1998H204.8V36.0998Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7 59.6996C178.3 59.6996 173.2 64.4996 173.2 71.1996C173.2 77.7996 178.4 82.6996 184.7 82.6996C191.1 82.6996 196.2 77.7996 196.2 71.1996C196.3 64.5996 191.1 59.6996 184.7 59.6996ZM184.7 78.1996C181.2 78.1996 178.2 75.2996 178.2 71.1996C178.2 67.0996 181.2 64.1996 184.7 64.1996C188.2 64.1996 191.2 66.9996 191.2 71.1996C191.2 75.2996 188.2 78.1996 184.7 78.1996ZM159.5 59.6996C153.1 59.6996 148 64.4996 148 71.1996C148 77.7996 153.2 82.6996 159.5 82.6996C165.9 82.6996 171 77.7996 171 71.1996C171.1 64.5996 165.9 59.6996 159.5 59.6996ZM159.5 78.1996C156 78.1996 153 75.2996 153 71.1996C153 67.0996 156 64.1996 159.5 64.1996C163 64.1996 166 66.9996 166 71.1996C166 75.2996 163 78.1996 159.5 78.1996ZM129.6 63.2996V68.1996H141.3C141 70.8996 140 72.8996 138.6 74.2996C136.9 75.9996 134.2 77.8996 129.6 77.8996C122.4 77.8996 116.8 72.0996 116.8 64.8996C116.8 57.6996 122.4 51.8996 129.6 51.8996C133.5 51.8996 136.3 53.3996 138.4 55.3996L141.8 51.9996C138.9 49.1996 135 47.0996 129.6 47.0996C119.8 47.0996 111.5 55.0996 111.5 64.9996C111.5 74.7996 119.8 82.8996 129.6 82.8996C134.9 82.8996 138.9 81.1996 142.1 77.8996C145.3 74.6996 146.3 70.0996 146.3 66.4996C146.3 65.3996 146.2 64.2996 146 63.4996H129.6V63.2996ZM252.1 67.0996C251.1 64.4996 248.2 59.7996 242.3 59.7996C236.4 59.7996 231.5 64.4996 231.5 71.2996C231.5 77.6996 236.4 82.7996 242.9 82.7996C248.2 82.7996 251.2 79.5996 252.5 77.6996L248.6 75.0996C247.3 76.9996 245.5 78.2996 242.9 78.2996C240.3 78.2996 238.5 77.0996 237.3 74.7996L252.7 68.3996L252.1 67.0996ZM236.4 70.8996C236.3 66.4996 239.8 64.1996 242.4 64.1996C244.4 64.1996 246.1 65.1996 246.7 66.5996L236.4 70.8996ZM223.9 81.9996H229V48.1996H223.9V81.9996ZM215.6 62.2996H215.4C214.3 60.8996 212.1 59.6996 209.3 59.6996C203.6 59.6996 198.3 64.7996 198.3 71.1996C198.3 77.5996 203.6 82.6996 209.3 82.6996C212 82.6996 214.2 81.4996 215.4 80.0996H215.6V81.7996C215.6 86.1996 213.2 88.5996 209.5 88.5996C206.4 88.5996 204.5 86.3996 203.7 84.4996L199.3 86.2996C200.6 89.2996 203.9 93.0996 209.5 93.0996C215.4 93.0996 220.4 89.5996 220.4 81.0996V60.4996H215.6V62.2996ZM209.8 78.1996C206.3 78.1996 203.4 75.2996 203.4 71.2996C203.4 67.1996 206.3 64.2996 209.8 64.2996C213.2 64.2996 215.9 67.2996 215.9 71.2996C216 75.2996 213.3 78.1996 209.8 78.1996ZM275.8 48.1996H263.7V81.9996H268.7V69.1996H275.7C281.3 69.1996 286.8 65.1996 286.8 58.6996C286.8 52.2996 281.3 48.1996 275.8 48.1996ZM275.9 64.4996H268.7V52.8996H275.9C279.7 52.8996 281.8 55.9996 281.8 58.6996C281.8 61.3996 279.7 64.4996 275.9 64.4996ZM307.1 59.6996C303.4 59.6996 299.7 61.2996 298.1 64.8996L302.6 66.7996C303.6 64.8996 305.3 64.2996 307.2 64.2996C309.8 64.2996 312.5 65.8996 312.5 68.5996V68.8996C311.6 68.3996 309.6 67.5996 307.2 67.5996C302.4 67.5996 297.5 70.2996 297.5 75.1996C297.5 79.6996 301.5 82.5996 305.9 82.5996C309.3 82.5996 311.2 81.0996 312.3 79.2996H312.5V81.8996H317.4V68.8996C317.3 62.9996 312.8 59.6996 307.1 59.6996ZM306.5 78.1996C304.8 78.1996 302.5 77.3996 302.5 75.2996C302.5 72.6996 305.4 71.6996 307.8 71.6996C310 71.6996 311.1 72.1996 312.4 72.7996C312.1 75.9996 309.4 78.1996 306.5 78.1996ZM335.1 60.3996L329.3 75.0996H329.1L323.1 60.3996H317.7L326.7 80.8996L321.6 92.2996H326.9L340.8 60.3996H335.1ZM289.6 81.9996H294.6V48.1996H289.6V81.9996Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9 21.5C28 22.3 27.5 23.7 27.5 25.5V25.1V84.9V84.5C27.5 86.2 28 87.5 28.8 88.3L29 88.5L62.5 55L28.9 21.5Z",
    fill: "url(#paint0_linear_412_170)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4999 56.5998C89.0999 57.4998 88.1999 58.2998 87.0999 58.8998C88.1999 58.1998 89.0999 57.3998 89.4999 56.5998ZM73.5999 43.7998L62.3999 54.9998L73.5999 66.1998L87.0999 58.4998C88.7999 57.4998 89.7999 56.2998 89.8999 54.9998C89.6999 53.6998 88.7999 52.4998 87.0999 51.4998L73.5999 43.7998Z",
    fill: "url(#paint1_linear_412_170)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9002 88.9C29.5002 89.5 30.4002 89.8 31.3002 89.8C30.4002 89.8 29.6002 89.5 28.9002 88.9ZM62.4002 55L28.9002 88.5C29.5002 89.1 30.4002 89.4 31.3002 89.4C32.2002 89.4 33.2002 89.1 34.3002 88.5L73.5002 66.2L62.4002 55Z",
    fill: "url(#paint2_linear_412_170)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2999 20.5997C30.3999 20.5997 29.4999 20.8997 28.8999 21.4997L62.3999 54.9997L73.5999 43.7997L34.3999 21.4997C33.1999 20.8997 32.1999 20.5997 31.2999 20.5997Z",
    fill: "url(#paint3_linear_412_170)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3002 88.9004C33.4002 89.4004 32.5002 89.7004 31.7002 89.8004C32.6002 89.7004 33.4002 89.4004 34.3002 88.9004Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5998 66.2002L34.3998 88.5002C33.2998 89.1002 32.2998 89.4002 31.3998 89.4002C30.4998 89.4002 29.5998 89.1002 28.9998 88.5002L28.7998 88.7002L28.9998 88.9002C29.5998 89.5002 30.4998 89.8002 31.3998 89.8002C31.5998 89.8002 31.6998 89.8002 31.8998 89.8002C32.6998 89.7002 33.5998 89.4002 34.4998 88.9002L73.9998 66.5002L73.5998 66.2002Z",
    fill: "url(#paint4_linear_412_170)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 84.9004C27.5 86.6004 28 87.9004 28.8 88.7004C27.9 87.9004 27.5 86.6004 27.5 84.9004Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 84.5V84.9C27.5 86.6 28 87.9 28.8 88.7L29 88.5L28.8 88.3C27.9 87.5 27.5 86.2 27.5 84.5Z",
    fill: "url(#paint5_linear_412_170)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9002 88.5L28.7002 88.7L28.9002 88.5Z",
    fill: "url(#paint6_linear_412_170)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9001 55C89.7001 56.3 88.8001 57.5 87.1001 58.5L73.6001 66.2L73.9001 66.5L87.1001 59C88.3001 58.3 89.1001 57.5 89.5001 56.7C89.8001 56.1 89.9001 55.5 89.9001 55Z",
    fill: "url(#paint7_linear_412_170)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6001 66.2002L73.8001 66.4002L73.6001 66.2002Z",
    fill: "url(#paint8_linear_412_170)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 20.1997C29.2 20.1997 27.7 21.7997 27.5 24.5997C27.6 23.1997 28 22.0997 28.7 21.2997L28.9 21.0997C29.5 20.4997 30.4 20.1997 31.3 20.1997Z",
    fill: "#404040"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7 21.2998C28 21.9998 27.6 23.1998 27.5 24.5998C27.5 24.7998 27.5 24.8998 27.5 25.0998V25.4998C27.5 23.6998 28 22.2998 28.9 21.4998L28.7 21.2998Z",
    fill: "url(#paint9_linear_412_170)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8 43.6001L73.5 43.9001L87 51.6001C88.7 52.6001 89.7 53.8001 89.8 55.1001C89.8 53.7001 88.9 52.3001 87 51.2001L73.8 43.6001Z",
    fill: "url(#paint10_linear_412_170)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3002 20.1997C30.4002 20.1997 29.5002 20.4997 28.9002 21.0997L28.7002 21.2997L28.9002 21.4997C29.5002 20.8997 30.4002 20.5997 31.3002 20.5997C32.2002 20.5997 33.2002 20.8997 34.3002 21.4997L73.5002 43.7997L73.8002 43.4997L34.3002 21.0997C33.2002 20.4997 32.2002 20.1997 31.3002 20.1997Z",
    fill: "url(#paint11_linear_412_170)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_170",
    x1: 59.4562,
    y1: 24.4925,
    x2: 14.0815,
    y2: 69.8672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_170",
    x1: 91.9725,
    y1: 55.1508,
    x2: 26.5512,
    y2: 55.1508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_412_170",
    x1: 67.633,
    y1: 61.22,
    x2: 6.10139,
    y2: 122.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_412_170",
    x1: 20.2416,
    y1: 1.38961,
    x2: 47.7181,
    y2: 28.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_412_170",
    x1: 67.7064,
    y1: 61.2941,
    x2: 6.1749,
    y2: 122.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_412_170",
    x1: 74.8565,
    y1: 39.896,
    x2: 29.4815,
    y2: 85.2709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_412_170",
    x1: 61.903,
    y1: 55.4904,
    x2: 0.369374,
    y2: 117.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_412_170",
    x1: 91.9717,
    y1: 60.7492,
    x2: 26.5506,
    y2: 60.7492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_412_170",
    x1: -319.303,
    y1: 37.3662,
    x2: -319.303,
    y2: 37.3663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_412_170",
    x1: 43.2296,
    y1: 8.26715,
    x2: -2.14525,
    y2: 53.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#40B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#40CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#40DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40EAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_412_170",
    x1: 91.9787,
    y1: 49.3531,
    x2: 26.5572,
    y2: 49.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_412_170",
    x1: 20.2419,
    y1: 1.38962,
    x2: 47.7184,
    y2: 28.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.21265baecb0a4293c784254d09427072.svg";
export { ForwardRef as ReactComponent };